import React from 'react'

import Button from 'components/base/Button'
import Loading from 'components/base/Loading'
import Paragraph, { Theme as ParagraphTheme } from 'components/base/Paragraph'

import PostExcerpt from 'components/blocks/Blog/PostExcerpt'

import { Props } from './types'

import {
  ButtonFooter,
  Wrap,
} from './styles'

const BlogPostsGrid: React.FC<Props> = ({
  isLoading,
  onClickViewMore,
  posts,
  pagination: { has_more: hasMore } = {},
}): React.ReactElement => (isLoading && <Loading />) || (posts && (
  <Wrap>
    {(posts.length && posts.map(post => <PostExcerpt key={post.slug} {...post} />)) || <Paragraph>No posts found.</Paragraph>}
    {hasMore && (
      <ButtonFooter>
        <Button onClick={onClickViewMore}>View More</Button>
      </ButtonFooter>
    )}
  </Wrap>
)) || <Paragraph theme={ParagraphTheme.centered}>An error has occurred.</Paragraph>

export default BlogPostsGrid
